'use client';
var DEFAULT_COLORS = {
    green: {
        950: "#2D3D29",
        920: "#344422",
        900: "#547012",
        800: "#81A11A",
        600: "#97BA1E",
        200: "#D4E3AC",
        50: "#F4F9E6"
    },
    emerald: {
        950: "#243D3D",
        920: "#1B534F",
        900: "#0E6A5E",
        800: "#1B897A",
        600: "#21A795",
        200: "#A1E1D9",
        50: "#E8FAF7"
    },
    turquoise: {
        950: "#29393D",
        920: "#124953",
        900: "#075C68",
        800: "#0B7483",
        600: "#00A4BA",
        200: "#8CE3EA",
        50: "#E8F9FB"
    },
    blue: {
        950: "#1F3351",
        920: "#293D6A",
        900: "#19468D",
        800: "#395CB1",
        600: "#577EDC",
        200: "#AABFFC",
        50: "#EBF1FF"
    },
    violet: {
        950: "#302C44",
        920: "#3E3060",
        900: "#4E3479",
        800: "#62419B",
        600: "#7E57C2",
        200: "#BEABE0",
        50: "#EFE9FB"
    },
    pink: {
        950: "#3D2931",
        920: "#713547",
        900: "#972F47",
        800: "#C94C6A",
        600: "#F85B80",
        200: "#FBADBF",
        50: "#FFEDF3"
    },
    red: {
        950: "#3D292E",
        920: "#6D2E34",
        900: "#912E34",
        800: "#C13E45",
        600: "#F14D56",
        200: "#F7949A",
        50: "#FEEDEE"
    },
    orange: {
        950: "#3F2F27",
        920: "#754530",
        900: "#965817",
        800: "#C87520",
        600: "#FF991F",
        200: "#FCD3A9",
        50: "#FFF4E9"
    },
    yellow: {
        950: "#4D431A",
        920: "#7E6409",
        900: "#967500",
        800: "#E4BC00",
        600: "#FBD522",
        200: "#FFEC94",
        50: "#FFFAE1"
    },
    corpomarine: {
        950: "#29393D",
        920: "#124753",
        900: "#1B606F",
        800: "#097789",
        600: "#00A1AE",
        200: "#A3E1E7",
        50: "#E7F9F9"
    },
    brand: {
        950: "#2D3D29",
        920: "#344422",
        900: "#547012",
        800: "#81A11A",
        600: "#97BA1E",
        200: "#D4E3AC",
        50: "#F4F9E6"
    }
};

export { DEFAULT_COLORS };
